import { definePart } from '../core/effect';
import { rgba } from '../canvas/paint';

/**
 * **放射状のにじみ**（Issue #528）。光るものの下地。
 *
 * **`blend: 'add'` が既定** —— 透過のキャンバスに黒へ落ちるグラデーションを描くと、
 * 重なったところが黒ずむ。加算合成なら下の絵を明るくするだけで済む。
 * にじみは `shadowBlur` ではなく**グラデーションそのもの**で出す（毎フレーム描き直す紙では影は重い）。
 */
export default definePart({
  id: 'glow',
  /** 素の大きさ（`{ screen: [x, y] }` は点なのでアンカーから取れない。Issue #537） */
  size: { w: 520, h: 520 },
  label: '光のにじみ',
  blend: 'add',
  schema: {
    color: { type: 'color', label: '色' },
    core: { type: 'number', label: '芯の太さ', min: 0, max: 1, step: 0.01 },
    falloff: { type: 'number', label: '落ち方', min: 0.5, max: 4, step: 0.1 },
  },
  style: { color: '#ffd76a', core: 0.18, falloff: 1.8 },

  draw(ctx, { size, style }) {
    const cx = size.w / 2;
    const cy = size.h / 2;
    const r = Math.max(size.w, size.h) / 2;
    if (r <= 0) return;
    const g = ctx.createRadialGradient(cx, cy, 0, cx, cy, r);
    const core = Math.min(0.99, Math.max(0, style.core));
    g.addColorStop(0, rgba(style.color, 1));
    g.addColorStop(core, rgba(style.color, 1));
    // **中間点を足す**（2 点だけだと直線に落ちて縁が見える）
    for (let i = 1; i <= 6; i += 1) {
      const t = core + ((1 - core) * i) / 7;
      g.addColorStop(t, rgba(style.color, (1 - (i / 7)) ** style.falloff));
    }
    g.addColorStop(1, rgba(style.color, 0));
    ctx.fillStyle = g;
    ctx.fillRect(0, 0, size.w, size.h);
  },
});
